export const FETCH_TAXES = 'FETCH_TAXES';
export const FETCH_TAX = 'FETCH_TAX';
export const UPDATE_TAX = 'UPDATE_TAX';
export const ADD_TAX = 'ADD_TAX';
export const DELETE_TAX = 'DELETE_TAX';
export const TAXES_FORM_DETAILS = 'taxesForm/details';
export const TAXES_FORM_SHOPS = 'taxesForm/shops';
export const TAXES_FORM_PRODUCTS = 'taxesForm/products';
export const TAXES_FORM_SERVICES = 'taxesForm/services';
